export function getUrl() {
  const protocol = process.env.NEXT_PUBLIC_VERCEL_URL?.startsWith('localhost')
    ? 'http://'
    : 'https://';

  return `${protocol}${process.env.NEXT_PUBLIC_VERCEL_URL}`;
}
